import React from 'react';

const tileLayers = {
  hydda: {
    url: 'https://{s}.tile.openstreetmap.se/hydda/full/{z}/{x}/{y}.png',
    attribution:
      "Tiles courtesy of <a href='http://openstreetmap.se/' target='_blank'>OpenStreetMap Sweden</a> &mdash; Map data &copy; <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>",
  },
  osm: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  },
  wikimedia: {
    url: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png',
    attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
  },
};

export default class LeafletTileLayer extends React.Component {
  render() {
    const { leaflet } = this.props;
    if (leaflet == null) return null;

    const props = tileLayers[global.CLIENT_ENV.MAP_TILE_LAYER] || tileLayers.osm;
    return <leaflet.TileLayer {...props} />;
  }
}
